/**
 * /admin shell — header + segmented control + <Outlet> for the three
 * sub-views (Overview / Reported / Feedback). Mirrors SkillsLayout.
 *
 * Owner-only: mounted behind <RequireAdmin> in App.tsx, and every backend
 * call it makes is server-gated by `require_admin`.
 */

import { NavLink, Outlet } from "react-router-dom";

const TABS = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/users", label: "Users", end: false },
  { to: "/admin/spots", label: "Spots", end: false },
  { to: "/admin/announce", label: "Announce", end: false },
  { to: "/admin/reported", label: "Reported", end: false },
  { to: "/admin/feedback", label: "Feedback", end: false },
];

export function AdminLayout() {
  return (
    <div className="max-w-4xl mx-auto px-4 md:px-8 py-8 space-y-6">
      <header>
        <h1 className="text-2xl font-bold text-text">Admin</h1>
        <p className="text-sm text-text-muted mt-1">
          Usage, the reported-spot review queue, and user feedback.
        </p>
      </header>

      <div
        role="tablist"
        className="flex gap-1 rounded-xl border border-border bg-surface p-1"
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            role="tab"
            className={({ isActive }) =>
              [
                "flex-1 text-center text-sm font-medium rounded-lg py-2 transition",
                isActive
                  ? "bg-accent/15 text-accent"
                  : "text-text-muted hover:text-text hover:bg-text/5",
              ].join(" ")
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
